import styled, { css } from 'styled-components'

export const CheggHeaderWrapper = styled.div<{
  headerPosition: string
}>`
  /* this exists because of the <Tour> clipping into fixed elements */
  ${({ headerPosition }) =>
    css`
      > div:first-of-type {
        position: ${headerPosition};
      }
    `}

  // fix issue for safari
  a {
    text-decoration: none;
  }
`

export const Content = styled.div<{ isGuest: boolean }>`
  ${({ isGuest }) =>
    isGuest &&
    css`
      padding-top: 66px;
    `}
`
